import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'

const sizes = [
	{
		label: '10px',
		style: 'fontsize-10'
	},
	{
		label: '12px',
		style: 'fontsize-12'
	},
	{
		label: '14px',
		style: 'fontsize-14'
	},
	{
		label: '16px',
		style: 'fontsize-16'
	},
	{
		label: '18px',
		style: 'fontsize-18'
	},
	{
		label: '20px',
		style: 'fontsize-20'
	},
	{
		label: '22px',
		style: 'fontsize-22'
	},
	{
		label: '24px',
		style: 'fontsize-24'
	},
	{
		label: '26px',
		style: 'fontsize-26'
	},
	{
		label: '28px',
		style: 'fontsize-28'
	},
	{
		label: '30px',
		style: 'fontsize-30'
	}
]

const Font = ({target, style, onToggle, handleClose}) => {
	const onClick = (e) => {
		const size = e.currentTarget.getAttribute('data-value')
		e.preventDefault()
		onToggle(size)
	}

    return (
		<Menu
			anchorEl={target}
			open={true}
			onClose={handleClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'center',
			}}
		>
			{sizes.map(size =>
				<MenuItem
					key={size.label}
					selected={style.has(size.style)}
					onClick={onClick}
					data-value={size.style}
				>
					{size.label}
				</MenuItem>
            )}
		</Menu>
    )
}

export default Font
